import axios from 'axios'
import { API_ROOT } from '@/api/config'
import storage from '@/plugins/storage'
import { toFormdata } from '@/constants/global/util'

const defaultConfig = {
  ...storage.get('access_token'),
  locale: storage.get('locale')
}

const apiKey = {
  'geolocation': 'AIzaSyDg6J36Wlb4QJfEx8aVuiqBHupSHRGmopE',
  'geocoding': 'AIzaSyCdxGQcBY7afNWZIc9hzULGfVBa2uDfjP4'
}

// geo
export const postGeolocation = () => axios.post('https://www.googleapis.com/geolocation/v1/geolocate?key=' + apiKey['geolocation'])
export const getGeoCoding = (lat, lng) => axios.get('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + [lat, lng].join(',') + '&key=' + apiKey['geocoding'] + '&language=en')
// user
export const getUser = (config) => axios.get(API_ROOT + 'users/current', { params: { ...defaultConfig, ...config } })
export const postUser = (data, config) => axios.post(API_ROOT + 'users/sign_in', data, { params: { ...defaultConfig, ...config } })
export const deleteUser = (config) => axios.delete(API_ROOT + 'users/sign_out', { params: { ...defaultConfig, ...config } })
